import EventEmitter from "eventemitter3";
export class Eventbus {
    constructor() {
        this.eventEmitter = new EventEmitter();
    }
    on(MsgType, listener, context) {
        const msg = new MsgType();
        this.eventEmitter.on(msg.naming, msg => {
            listener(msg);
        }, context);
    }
    off(MsgType, listener, context) {
        const msg = new MsgType();
        this.eventEmitter.off(msg.naming, listener, context);
    }
    offAll(MsgType) {
        const msg = new MsgType();
        this.eventEmitter.removeAllListeners(msg.naming);
    }
    emit(msg) {
        const that = this;
        setTimeout(() => {
            that.eventEmitter.emit(msg.naming, msg);
        });
    }
}
export const eventbus = new Eventbus();
